const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/cashRegister',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    locale: 'fr',
    enableMock: true,
}

export default appConfig
